/**
 *
 * @param contentUrl - the path, e.g. /uploads/media/123.pdf
 * @returns The full file href, e.g. https://uat-api.nzcerassist.org.nz/uploads/media/123.pdf
 */
export function fileDownloadHref(contentUrl: string): string {
  return `${BACKEND_URL}${contentUrl}`;
}
